import { Component, Vue } from 'types-vue'

@Component
export default class UserConfiguration extends Vue {}